




















































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { store } from "../store/mainStore";
import DesenvolvedorPleno from "../components/vagas/DesenvolvedorPleno.vue";
import Desenvolvedor from "../components/vagas/Desenvolvedor.vue";
import DesenvolvedorEstagio from "../components/vagas/DesenvolvedorEstagio.vue";
import Suporte from "../components/vagas/Suporte.vue";
import SuporteEstagio from "../components/vagas/SuporteEstagio.vue";
import Designer from "../components/vagas/Designer.vue";
import DesignerEstagio from "../components/vagas/DesignerEstagio.vue";
import Administrativo from "../components/vagas/Administrativo.vue";

@Component({
  components: {
    DesenvolvedorPleno,
    Desenvolvedor,
    DesenvolvedorEstagio,
    Suporte,
    SuporteEstagio,
    Designer,
    DesignerEstagio,
    Administrativo,
  },
})
export default class Rodape extends Vue {
  data() {
    return {
      dialog: false,
      dialogMD: false,
    };
  }
}
